<template>
  <section class="hero is-fullheight cart-page">
    <PmNavbar />

    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-9">
            <div class="columns p-5 white-bg">
              <div class="column is-12">
                <h1 class="is-ubuntu font-secondary has-text-centered-mobile">Omat tilisi</h1>
              </div>
            </div>

            <div class="columns p-5 white-bg" v-if="account!= null">
              <div class="column is-12">
                <h3 class="is-ubuntu font-secondary has-text-centered-mobile">Hei {{account.contact.recv_name}}</h3>
              </div>
            </div>

          <div class="columns is-multiline p-5 white-bg has-text-centered-mobile" v-if="account">
            <div class="column is-12">
              <p class="is-ubuntu font-secondary">{{ account.email }}</p>
            </div>

            <div class="column is-6">
              <h3 class="title is-5">Yhteystiedot</h3>
            </div>

            <div class="column is-6">
              <h3 class="title is-5">Laskutusosoite</h3>
            </div>

            <div class="column is-6" v-if="account.contact">
              <div v-if="!editMode">
                <p><strong>Yritys/Yhdistys:</strong> {{ account.contact.recv_company }}</p>
                <p><strong>Yhteyshenkilö:</strong> {{ account.contact.recv_name }}</p>
                <p><strong>Puhelinnumero:</strong> {{ account.contact.recv_phone }}</p>
                <p><strong>Katuosoite:</strong> {{ account.contact.recv_street }}</p>
                <p><strong>Postinumero:</strong> {{ account.contact.recv_zip }}</p>
                <p><strong>Postitoimipaikka:</strong> {{ account.contact.recv_town }}</p>
              </div>

              <div v-else>
              <label>Yritys/Yhdistys *</label>
              <input v-model="form.recv_company" class="input pm-input mb-3" placeholder="Yritys/Yhdistys *" />
              <label>Yhteyshenkilö *</label>
              <input v-model="form.recv_name" class="input pm-input mb-3" placeholder="Yhteyshenkilö *" />
              <label>Puhelinnumero *</label>
              <input v-model="form.recv_phone" class="input pm-input mb-3" placeholder="Puhelinnumero *" />
              <label>Katuosoite *</label>
              <input v-model="form.recv_street" class="input pm-input mb-3" placeholder="Katuosoite *" />
              <label>Postinumero *</label>
              <input v-model="form.recv_zip" class="input pm-input mb-3" placeholder="Postinumero *" />
              <label>Postitoimipaikka *</label>
              <input v-model="form.recv_town" class="input pm-input mb-3" placeholder="Postitoimipaikka *" />
              </div>

            </div>

            <div class="column is-6" v-if="account.contact">
              <div v-if="!editMode">
                <p><strong>Yritys/Yhdistys:</strong> {{ account.contact.bill_company }}</p>
                <p><strong>Yhteyshenkilö:</strong> {{ account.contact.bill_name }}</p>
                <p><strong>Puhelinnumero:</strong> {{ account.contact.bill_phone }}</p>
                <p><strong>Katuosoite:</strong> {{ account.contact.bill_street }}</p>
                <p><strong>Postinumero:</strong> {{ account.contact.bill_zip }}</p>
                <p><strong>Postitoimipaikka:</strong> {{ account.contact.bill_town }}</p>
              </div>

              <div v-else>
                <label>Yritys/Yhdistys *</label>
                <input v-model="form.bill_company" class="input pm-input mb-3" placeholder="Yritys/Yhdistys *" />
                <label>Yhteyshenkilö *</label>
                <input v-model="form.bill_name" class="input pm-input mb-3" placeholder="Yhteyshenkilö *" />
                <label>Puhelinnumero *</label>
                <input v-model="form.bill_phone" class="input pm-input mb-3" placeholder="Puhelinnumero *" />
                <label>Katuosoite *</label>
                <input v-model="form.bill_street" class="input pm-input mb-3" placeholder="Katuosoite *" />
                <label>Postinumero *</label>
                <input v-model="form.bill_zip" class="input pm-input mb-3" placeholder="Postinumero *" />
                <label>Postitoimipaikka *</label>
                <input v-model="form.bill_town" class="input pm-input mb-3" placeholder="Postitoimipaikka *" />
              </div>

            </div>

            <div class="column is-12" v-if="account.contact">
              <div v-if="!editMode">
                <p><strong>Y-tunnus *:</strong> {{ account.contact.cust_vat_nr }}</p>
              </div>
              <div v-else>
                <label>Y-tunnus *</label>
                <input v-model="form.cust_vat_nr" class="input mb-2" placeholder="Customer VAT" />
              </div>
            </div>

            <button class="pyroll-button purple-bg font-white mt-5" @click="editMode ? saveInformation() : editInformation()">
              {{ editMode ? 'Päivitä omia tietoja' : 'Päivitä omia tietoja' }}
            </button>
            <button v-if="editMode" class="pyroll-button purple-bg font-white mt-5 ml-5" @click="editMode=false">
              Sulje
            </button>
            <button class="pyroll-button purple-bg font-white mt-5 ml-5-desktop" @click="this.$router.push({ name: 'Landing' })">
              Jatka kauppaan
            </button>
          </div>


          </div>
          <div class="column is-3 side-menu has-text-centered-mobile">
            <ul class="gray-bottom-border pb-5">
              <li>
                <a @click="$router.push({name: 'Designs'})">
                  Omat tilaukseni
                </a>
              </li>
              <li>
                <a @click="$router.push({name: 'ChangePassword'})">
                  Vaihda salasanaa
                </a>
              </li>
              <li>
                <a @click="logout()">
                  Kirjaudu ulos
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <PmFooter />
  </section>
</template>

<script>
import PmNavbar from '../components/PmNavbar'
import PmFooter from '../components/PmFooter'
import { ref } from 'vue'
import asModalDialog from "@/helpers/asModalDialog"
import {mapActions, mapGetters, mapMutations} from "vuex"
import preview3d from "@/3d/preview3d"

export default {
  components: {
    PmNavbar,
    PmFooter,
  },
  data() {
    return {
      editMode: false,
      form: {
        recv_name: '',
        recv_company: '',
        recv_phone: '',
        recv_street: '',
        recv_zip: '',
        recv_town: '',
        bill_name: '',
        bill_company: '',
        bill_phone: '',
        bill_street: '',
        bill_zip: '',
        bill_town: '',
        cust_email: '',
        cust_vat_nr: ''
      }
    }
  },
  mounted() {
    this.setSpinnerState(false)
    this.getOrders().then(() => {
      this.getDesigns().then(() => {
        this.getAccount().then(() => {

        })
      })
    })
  },
  methods: {
    ...mapActions({
      getDesigns: 'getDesigns',
      getOrders: 'getOrders',
      getAccount: 'getAccount'
    }),
    ...mapMutations({
      setSpinnerState: 'setSpinnerState',
      resetStore: 'resetStore'
    }),
    ...mapGetters({
      getAccountInfo: 'getAccountInfo'
    }),
    logout() {
      this.resetStore()
      this.$router.push({ name: 'Landing' })
    },
    editInformation() {
      this.form = { ...this.account.contact };
      this.editMode = true;
    },
    saveInformation() {
      this.$store.dispatch('updateContact', {
        id: this.account.contact.id,
        ...this.form
      }).then(() => {
        this.editMode = false;
      });
    }
  },
  computed: {
    account() {
      return this.$store.getters.getAccountInfo
    }
  },
}
</script>

<style scoped lang="scss">
@use '../assets/sass/variables' as *;
.cart-page {
  .container {
    padding-left: 12px;
    padding-right: 12px;
  }

  .custom-black {
    color: $font-color-primary;
  }

  .white-bg {
    background-color: #ffffff;
  }

  .amount-input {
    width: 66px;
    height: 31px;
    background-color: #DEDBD9;
  }
  .border-bottom {
    border-bottom: 1px solid #707070;
  }
  .visibility-hidden {
    visibility: hidden;
  }

  // Remove arrows in number input type
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  .svg-inline--fa {
    cursor: pointer;
  }

  .mandatory-fields-text {
    color: #DEDBD9;
  }
}

span.is-clickable {
  color: $pyroll-violet;
  svg {
    width: 20px;
    height: 20px;
  }
}

.text-wrapper {
  text-overflow: ellipsis;
  overflow: hidden;
}

.side-menu {
  a {
    text-decoration: underline;
  }
  a:hover {
    font-weight: bold;
  }
}

.gray-bottom-border {
  border-bottom: 2px solid #D0D3D4;
}

@media (min-width: 1024px) {
  .ml-5-desktop {
    margin-left: 1.25rem !important;
  }
}
</style>
